import { render } from "./LoadingVue.vue?vue&type=template&id=35a8a366&scoped=true"
import script from "./LoadingVue.vue?vue&type=script&lang=js"
export * from "./LoadingVue.vue?vue&type=script&lang=js"

import "./LoadingVue.vue?vue&type=style&index=0&id=35a8a366&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a8a366"]])

export default __exports__